app.views.consent = app.views.base.extend({
  attr: {
    success: 'data-form-success',
    spinner: 'data-form-spinner'
  },
  /**
   * Initialise Contact ViewListener
   * Listens for the consent page being loaded by the browser.
   * @public
   * @constructor
   */

  init: function init() {},
  onSuccessfulSubmission: function onSuccessfulSubmission(id) {
    var form = $(id);
    $('[' + this.attr.success + ']').show();
    dataLayer.push({
      event: 'formSubmission',
      formType: 'Consent'
    });
    app.initElementListeners(form);
  }
});